module.exports = __webpack_public_path__ + "static/img/IMG_20160307_141104.b6056b18.jpg";